module.exports = __webpack_public_path__ + "static/media/redcat2.7c30d836.png";